import React, { useEffect, useRef } from "react";
import work from "./WorkArray";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Rotate from "../logo/Rotate.jpg";
import Projects from "./Projects";
import Illustration from "./Illustration";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

gsap.registerPlugin(ScrollTrigger);

const Work = () => {
  let reff = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });
  useEffect(() => {
    const element = reff.current;
    const title = element.querySelector(".title");
    const img = element.querySelector("img");
    const heading = element.querySelector(".heading");

    gsap.fromTo(
      title,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: title,
          start: "top bottom-=10",
        },
      },
    );

    gsap.fromTo(
      img,
      0.6,
      { opacity: 0 },
      {
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: title,
          start: "top bottom-=10",
        },
      },
    );

    gsap.fromTo(
      heading,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: heading,
          start: "top bottom-=10",
        },
      },
    );
  }, []);

  useEffect(() => {
    const menu = document.querySelectorAll(".nav-link");
    if (inView) {
      menu[3].classList.add("active");
      menu[0].classList.remove("active");
      menu[1].classList.remove("active");
      menu[2].classList.remove("active");
      menu[4].classList.remove("active");
    }
  }, [inView]);

  return (
    <section data-scroll-section ref={ref}>
      <motion.section
        initial={{ visibility: "hidden" }}
        animate={{ visibility: "visible", transition: { delay: 1 } }}
        exit={{ visibility: "hidden", transition: { delay: 1 } }}
        id="projects"
      >
        <div className="container">
          <div className="work" ref={reff}>
            <div style={{ overflow: "hidden" }}>
              <h1 className="title">My Work</h1>
            </div>

            <div className="main">
              <div style={{ overflow: "hidden", width: "100%" }}>
                <h2 className="heading">
                  A collection of my designs and coding. These are a mix of
                  illustrations, websites and side projects.
                </h2>
              </div>
              <div className="rotate">
                <img src={Rotate} alt="Creativity-Design-Illustrations" />
              </div>
            </div>
          </div>
        </div>
      </motion.section>
      <main id="webDesign">
        <div className="projects">
          <div className="wrapper">
            {work.map((elem) => {
              const { id, src, title, github, desc, href, tech, offset } = elem;
              return (
                <Projects
                  key={id}
                  src={src}
                  href={href}
                  title={title}
                  tech={tech}
                  github={github}
                  desc={desc}
                  offset={offset}
                />
              );
            })}
          </div>
        </div>
      </main>
      <Illustration />
    </section>
  );
};

export default Work;
